export enum SubscriptionApiStatus {
  ACTIVE = "active",
  CANCELED = "canceled",
  PAST_DUE = "past_due",
  INACTIVE = "inactive",
  INCOMPLETE = "incomplete",
}

export enum SubscriptionApiState {
  "ACTIVE" = 0,
  "CHANGE_PLAN" = 1,
  "ACTIVE_RENOVATION_CANCELED" = 2,
  "PENDING_PAYMENT" = 3,
  "CANCELED" = 4,
  "EMPTY" = 5,
}

export interface SubscriptionApi {
  cancel_date: number | null;
  cancel_requested: boolean;
  end: number;
  invoice_stripe_id: string;
  is_promo: boolean;
  next_plan_uuid: string;
  plan_uuid: string;
  start: number;
  status: SubscriptionApiStatus;
  stripe_id: string;
  subscription_state: { id: number; metadata: string; date: number };
  date: number;
  id: number;
  metadata: number;
  user_uuid: string;
  uuid: string;
  video_calls: number;
  payment_intent: {
    last_payment_error: {
      code: string;
      decline_code: string;
      message: string;
    };
    status: string;
  };
}

export interface SubscribeApiQuery {
  plan_uuid: string;
  user_uuid: string;
  promo_plan_uuid?: string;
}

export interface SubscriptionApiQuery {
  customer_uuid: string;
}

export interface CancelSubscriptionApiQuery {
  user_uuid: string;
  cancel_reason_i18n: string;
  cancel_comment?: string;
}
export interface CancelSubscriptionApiQuery {
  user_uuid: string;
}

export interface UpdateSubscriptionStatusApiQuery {
  status: string;
}
